/* tslint:disable:no-any */

import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { AnchorModule } from '@epicuro-next/ataraxia/anchor';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { DontTreeShakeModuleAndComponents } from '@epicuro-next/elements/core';

import { LinkComponent } from './components/link/link.component';
import { MediaComponent } from './components/media/media.component';
import { PageMenuComponent } from './components/page-menu/page-menu.component';

const components: any[] | Type<any[]> = [
  PageMenuComponent,
  LinkComponent,
  MediaComponent,
];

@NgModule({
  imports: [CommonModule, AnchorModule, IconsModule, MediaPreviewModule],
  declarations: components,
  exports: components,
})
export class ContentComponentsModule {}

// This has a tech debt and needs to be fixed
DontTreeShakeModuleAndComponents(
  ContentComponentsModule,
  'ContentComponentsModule',
  components,
);
